import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';
import { PaymentScenarionConditionFormDto, type PaymentScenarionConditionFormInterface } from '@zaoblako/shared/modules/task/dtos/payment-scenarion/payment-scenarion-condition-form.dto';
import { PaymentScenarionActionFormDto, type PaymentScenarionActionFormInterface } from '@zaoblako/shared/modules/task/dtos/payment-scenarion/payment-scenarion-action-form.dto';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';

import * as yup from 'yup';

/** Payment scenarion request body */
export interface PaymentScenarionFormInterface {
  /** Unique identifier */
  id?: number;
  /** Payment scenarion deleted date and time */
  name: string;
  /** Action included in this scenarion */
  paymentScenarionAction: PaymentScenarionActionFormInterface;
  /** Conditions included in this scenarion */
  conditions: PaymentScenarionConditionFormInterface[];
}

/** Payment scenarion DTO */
export const PaymentScenarionFormDto = SerdeDtoClass.create<PaymentScenarionFormInterface>(
  TaskDtoKeysEnum.PAYMENT_SCENARION_FORM_DTO,
  {
    id: {
      optional: true,
      label: 'Номер',
      serializer: yup.number(),
    },
    name: {
      label: 'Имя',
      serializer: yup.string(),
    },
    paymentScenarionAction: {
      label: 'Действие',
      nested: PaymentScenarionActionFormDto,
      serializer: (_, nested) => nested,
    },
    conditions: {
      label: 'Привязанные условия',
      nested: PaymentScenarionConditionFormDto,
      serializer: (_, nested) => yup
        .array(nested)
        .min(1, DtoMessageEnum.EMPTY_ARRAY),
    },
  },
);
